import React from 'react';
import ViewCustomFields from '@Components/Common/CustomField/ViewCustomFields';
import { Divider } from 'antd';
import HideValue from '../RestrictedAccess/HideValue';
import './style.scss';

const MoreInfoMobileView = ({
  fields, description, customFields, descriptionLabel,
}) => (
  <div className="more-details__wrapper">
    <div className="ant-row">
      {fields?.map((field) => {
        const {
          label,
          value,
          dataMasking,
        } = field;

        return (
          <div className="ant-col-md-24 ant-col-xs-24" key={label}>
            <div className="more-details__sub__wrapper">
              <div className="more-details_info__heading">{label}</div>
              <div className="more-details_info__value">
                {dataMasking ? <HideValue showPopOver popOverMessage={`You don't have access to view ${label}`} /> : value}
              </div>
            </div>
          </div>
        );
      })}

      {description?.length > 0 && (
        <React.Fragment>
          <Divider
            orientation="left"
            plain
            style={{
              borderColor: 'rgb(190, 190, 190)',
              margin: '0px',
              marginBottom: '10px',
              fontWeight: 600,
              fontSize: '13px',
            }}
          >
            {descriptionLabel || 'Description'}
          </Divider>
          <div
            className="description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </React.Fragment>
      )}

      {customFields?.length > 0 && (
        <Divider
          orientation="left"
          plain
          style={{
            borderColor: 'rgb(190, 190, 190)',
            margin: '0px',
            marginBottom: '10px',
            fontWeight: 600,
            fontSize: '13px',
          }}
        >
          Custom Fields
        </Divider>
      )}
      <ViewCustomFields
        customFields={customFields}
        rootClass="more-details__root_wrapper"
        wrapperClass="more-details__sub__wrapper"
        labelClass="more-details_info__heading"
        valueClass="more-details_info__value"
      />
    </div>
  </div>
);

export default MoreInfoMobileView;
